import { Component, inject } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { LookupService } from '@core/services/lookup.service';
import { ICourses } from '@core/interfaces/ilookup';
import { Card } from '@core/models/card';
import { CardService } from '@core/services/card.service';
import { take, tap } from 'rxjs';

@Component({
  selector: 'prism-course-user',
  templateUrl: './course-user.component.html',
  styleUrl: './course-user.component.scss'
})
export class CourseUserComponent {
  private lookupService = inject(LookupService);
  private authService = inject(AuthService);
  private cardService = inject(CardService);
  private courseContainer = 'courses';

  courses: ICourses[] = [];
  sasToken: string = '';
  
  viewCourse = (card: Card) => this.cardService.viewCard(card.id!, '/course/');

  get courseList(): Card[] { 
    if (this.courses.length === 0) return [];
    return this.cardService.mapCardDataToDataList(this.courseContainer, this.courses, this.sasToken); 
  }

  ngOnInit(): void {
    this.getSasToken();
  }

  getSasToken(): void {
    this.authService.fetchSasToken(this.courseContainer, (token) => {
      this.sasToken = token;
      this.getCourses();
    });
  }

  getCourses(): void {
    this.lookupService.getCourses().pipe(
      take(1),
      tap((res: ICourses[]) => {
        this.courses = res;
      })
    ).subscribe();
  }
}
